/**
 * 複数タブでの操作を判定します。
 * あと勝ちです。
 * */
export module MultiTab {

	let isUsedAlready = false;

	export const INTERVAL = 3000;
	const TAB_ID = "POSCA_TAB_ID"

	/**
	 * 複数タブ禁止
	 * @param func OKボタン押下時のファンクション
	 */
	export function forbiddenMultiTab(func:Function) {

		// タブ単位
		const SESSION_TAB_ID = sessionStorage.getItem(TAB_ID);

		// ブラウザ単位
		const LOCAL_TAB_ID = localStorage.getItem(TAB_ID);

		let newAction = function () {
			let tabid = new Date().getTime().toString();
			sessionStorage.setItem(TAB_ID, tabid);
			localStorage.setItem(TAB_ID, tabid);
			isUsedAlready = true;
		}

		let oldAction = function () {
			func();
		}

		if (SESSION_TAB_ID == null || (SESSION_TAB_ID == LOCAL_TAB_ID && !isUsedAlready)) {
			// 初回もしくはタブが開かれた
			newAction();
		} else if (SESSION_TAB_ID == LOCAL_TAB_ID) {
			// タブが同じ -> NOP
		} else {
			// 別タブ
			oldAction();
		}

	}

	/**
	 * 古タブチェック
	 * 後勝ち仕様なので古いタブでは通信させない。
	 * */
	export function isOldTab(): boolean {

		// タブ単位
		const SESSION_TAB_ID = sessionStorage.getItem(TAB_ID);

		// ブラウザ単位
		const LOCAL_TAB_ID = localStorage.getItem(TAB_ID);

		let newAction = function () {
			let tabid = new Date().getTime().toString();
			sessionStorage.setItem(TAB_ID, tabid);
			localStorage.setItem(TAB_ID, tabid);
			isUsedAlready = true;
		}

		let rt = false;
		if (SESSION_TAB_ID == null || (SESSION_TAB_ID == LOCAL_TAB_ID && !isUsedAlready)) {
			// 初回もしくはタブが開かれた
			newAction();
			rt = false;
		} else if (SESSION_TAB_ID == LOCAL_TAB_ID) {
			// タブが同じ -> NOP
			rt = false;
		} else {
			// 別タブ
			rt = true;
		}

		return rt;

	}
}